import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=252a6c68&scoped=true&"
import script from "./Features.vue?vue&type=script&lang=js&"
export * from "./Features.vue?vue&type=script&lang=js&"
import style0 from "./Features.scss?vue&type=style&index=0&id=252a6c68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a6c68",
  null
  
)

export default component.exports